import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AgentReportModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { AwardsReportAction } from '../actions';
import { AwardsReportReducer } from '../reducers';
import { AwardsReportSelector } from '../selectors';

@Injectable()
export class AwardsReportFacade {
  selectedItem$ = this._store.select(AwardsReportSelector.selectAwardsReport);
  constructor(private _store: Store<AwardsReportReducer.AwardsReportState>) {}

  /**
   * Get @AwardsReportModel by id
   */
  getById(id: number): Observable<AgentReportModel | null> {
    this._store.dispatch(AwardsReportAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<AgentReportModel | null>;
  }
}
